var __vue_exports__, __vue_options__

/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!vue-loader/lib/style-rewriter?id=data-v-5&scoped=true!sass-loader?sourceMap!vue-loader/lib/selector?type=styles&index=0!./InvoiceTotal.vue")

/* script */
__vue_exports__ = require("!!babel-loader!vue-loader/lib/selector?type=script&index=0!./InvoiceTotal.vue")

/* template */
var __vue_template__ = require("!!vue-loader/lib/template-compiler?id=data-v-5!vue-loader/lib/selector?type=template&index=0!./InvoiceTotal.vue")
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
__vue_options__._scopeId = "data-v-5"

module.exports = __vue_exports__



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Products/InvoiceTotal.vue
 ** module id = 166
 ** module chunks = 2
 **/